import { createSlice } from '@reduxjs/toolkit';
import { baseOnboardingUrl } from './hooks';

const initialState = {
  // Modal-specific state
  baseUrl: baseOnboardingUrl,
  
  // Stage checklist data
  stageCheckList: {
    "sync-dental-resources": {
      "workflows": ["non-voip", "dso"],
      "description": "sync dental resources from PMS to the db"
    },
    "multi-account": {
      "workflows": ["non-voip", "dso"],
      "description": "all users who need access have been sent registration emails"
    },
    "dso-permissions": {
      "workflows": ["dso"],
      "description": "previous DSO users have had permissions updated for new practice"
    } 
  },
  
  // Loading and error states
  loading: false,
  error: null,
  
  // Success state
  success: false
};

const trainingKbSlice = createSlice({
  name: 'trainingKb',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  clearError,
  clearSuccess,
  setLoading
} = trainingKbSlice.actions;

// Selectors
export const selectBaseUrl = (state) => state.trainingKb.baseUrl;
export const selectStageCheckList = (state) => state.trainingKb.stageCheckList;
export const selectLoading = (state) => state.trainingKb.loading;
export const selectError = (state) => state.trainingKb.error;
export const selectSuccess = (state) => state.trainingKb.success;

export default trainingKbSlice.reducer;
